var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "btn-disabled-gray" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "div",
          {
            staticClass: "btn-toolbar mb-2 flex-grow-1",
            attrs: { "data-toggle": "buttons" }
          },
          _vm._l(_vm.tabs, function(item) {
            return _c(
              "button",
              {
                staticClass: "btn",
                class: {
                  "btn-primary active": _vm.selectedTab === item.tab,
                  "btn-link": _vm.selectedTab !== item.tab
                },
                on: {
                  click: function($event) {
                    _vm.selectedTab = item.tab
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.selectedTab === "duty"
          ? _c("DutySettingsButton", { on: { imported: _vm.onDutiesImported } })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.selectedTab === "cell" ? _c("div", [_c("CellUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedTab === "line" ? _c("div", [_c("LineUi")], 1) : _vm._e(),
    _vm._v(" "),
    _vm.selectedTab === "duty"
      ? _c("div", [_c("DutyUi", { ref: "dutyUi" })], 1)
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedTab === "inventory"
      ? _c("div", [_c("InventoryComponent")], 1)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }